import { equals } from '@execonline-inc/collections';
import { cn, emptyFragment, useDeviceDetect } from '@execonline-inc/execonline-ui';
import { toTask, when } from '@execonline-inc/maybe-adapter';
import { noop } from '@kofno/piper';
import { observer } from 'mobx-react';
import React from 'react';
import { State } from '../../Experiences/ExperiencesStore/Types';
import SearchBoxButton from './SearchBoxButton';
import SearchBoxField from './SearchBoxField';
import { useSearchBox } from './hooks';

interface Props {
  className: string;
  state: State;
  onSubmit: (value: string) => void;
}

function SearchBox({ className, state, onSubmit }: Props) {
  const { value, onChange } = useSearchBox(state);
  const deviceType = useDeviceDetect();

  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    toTask('validate-search-value', value).fork(noop, onSubmit);
  };

  return (
    <form className={cn('flex gap-2', className)} onSubmit={handleSubmit}>
      <SearchBoxField search={value} onChange={onChange} />
      {when(equals(deviceType, 'desktop'), true)
        .map(() => <SearchBoxButton disabled={value.isNothing()} />)
        .getOrElse(emptyFragment)}
    </form>
  );
}

export default observer(SearchBox);
